import React, { useMemo } from 'react'
import type { FC } from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import PinCodeField from 'redesign/components/atoms/pin-code-field'
import { MAX_ATTEMPTS } from './constants'
import { PinListWrapper, Wrapper } from './styles'
import type { PinCodeFieldRowProps } from './types'

const PinCodeFieldRow: FC<PinCodeFieldRowProps> = ({ pin, pinLength, attemptsLeft, pinInvalid }) => {
  const { t } = useFavurTranslation()
  const { palette } = useTheme()
  const areThereAttemptsLoaded = attemptsLeft !== undefined
  const error = useMemo(() => {
    if (pin || !areThereAttemptsLoaded || !pinInvalid) return false

    return attemptsLeft < MAX_ATTEMPTS
  }, [areThereAttemptsLoaded, attemptsLeft, pin, pinInvalid])

  return (
    <Wrapper error={error}>
      <PinListWrapper data-testid="pin-display">
        {Array(pinLength)
          .fill(0)
          .map((_value, digitNumber) => (
            <PinCodeField
              // eslint-disable-next-line react/no-array-index-key -- only available value for key
              key={digitNumber}
              hasValue={pin[digitNumber] !== undefined}
              selected={digitNumber === pin.length}
              error={error}
            />
          ))}
      </PinListWrapper>
      {areThereAttemptsLoaded && (
        <Typography variant="body1" color={error ? palette.error.dark : palette.text.primary}>
          {t('component.pinLogin.flash.text', { attemptsLeft })}
        </Typography>
      )}
    </Wrapper>
  )
}

export default PinCodeFieldRow
